export const translations = {
  en: {
    "nav.founders": "Founders",
    "nav.pathways": "Pathways",
    "nav.packages": "Packages",
    "nav.stories": "Stories",
    "nav.cta": "Let's Talk",
    "nav.login": "Login",
    "nav.dashboard": "Dashboard",
    "nav.admin": "Admin",

    "hero.kicker": "College Soccer Recruiting — US & Canada",
    "hero.l1": "The Crossing.",
    "hero.l2": "Your pathway to",
    "hero.l3a": "North American ",
    "hero.l3b": "soccer.",
    "hero.sub": "We build your recruiting profile, put it in front of coaches who actually have a spot in your position, and stay with you through your university career. Honest answers — even when the answer is junior college.",
    "hero.cta1": "Start your crossing",
    "hero.cta2": "Who we are",
    "hero.statline": "NCAA D1 · D2 · D3 — NAIA — NJCAA — U Sports",

    "founders.chapter": "Chapter 01 — The ones who crossed",
    "founders.h2a": "Run by two people who've made the crossing ",
    "founders.h2b": "themselves.",
    "founders.intro": "Peter went Texas to Canada. Lilian went France to Wales to Canada — Cape Breton, and now a new chapter at Algoma University. Two shores — and both of us have made the crossing. If you're a player in North America or Europe, we'll be on the other end of the DMs.",
    "founders.peterCap": "Goalkeeper — Texas → Canada",
    "founders.peterLabel": "Peter — The one they told to quit goalkeeping",
    "founders.peterBio": "At 10, a coach told him to think about another position. He didn't listen. He finished high school in Texas as a two-time first-team All-State keeper — and the only goalkeeper in the state to score twice on free kicks, one of them winning a state semi-final. Since then: scholarships at Algoma and Trinity Western, 1,000+ minutes of college soccer, semi-pro spells with Hill Country Lobos and Lake Travis FC. He's been the player waiting for opportunities that never came — he knows what rejection means, and how to overcome it.",
    "founders.peterAcademies": "GK academy @thekeeperslab · co-owner @eptsoccer",
    "founders.lilianLabel": "Lilian — France → Wales → Canada",
    "founders.lilianBio": "From Paris to Cardiff, then across the Atlantic to Cape Breton University — one of the country's top university soccer environments. Along the way he played semi-pro for Guelph United FC and Windsor City FC. Injuries and setbacks came too, but he kept moving forward. Now he's taking the next step: transferring to Algoma University for a fresh opportunity and a new chapter. He's lived recruitment, moving abroad, adapting to a new system — and the transfer process when things don't go as planned.",
    "founders.quote": "\u201cHonest feedback. Real guidance. Real opportunities. No filler, no false promises — even when the honest answer is junior college.\u201d",
    "founders.stripPeter": "Peter — between the posts",
    "founders.stripLilian": "Lilian — Capers matchday",

    "pathways.chapter": "Chapter 02 — Every door we open",
    "pathways.h2a": "Six pathways. ",
    "pathways.h2b": "One that's",
    "pathways.h2c": " honestly yours.",
    "pathways.d1": "The biggest stage — full-time programs, national broadcasts, the most demanding rosters. We only push you here if you genuinely belong.",
    "pathways.d1tag": "Athletic scholarships",
    "pathways.d2": "High-level soccer with real scholarship money and more balance. The right fit for a huge share of internationals.",
    "pathways.d2tag": "Partial & full rides",
    "pathways.d3": "No athletic scholarships — but serious soccer and strong academic merit aid. Often the smartest academic play.",
    "pathways.d3tag": "Merit aid route",
    "pathways.d4": "Competitive programs, flexible eligibility, and coaches who move fast. A real pathway, not a consolation.",
    "pathways.d4tag": "Scholarships available",
    "pathways.d5": "Junior college. Sometimes the honest answer — and sometimes the fastest route to a bigger offer two years later.",
    "pathways.d5tag": "The honest answer",
    "pathways.d6": "U SPORTS is Canada's top university league — highly competitive, with a level of play that surprises a lot of players who assume it's a step down from the NCAA.",
    "pathways.d6tag": "Home turf",

    "pricing.chapter": "Chapter 03 — The packages",
    "pricing.h2a": "Pick your ",
    "pricing.h2b": "crossing.",
    "pricing.intro": "Pricing is tailored to your journey and your timeline — every engagement starts with a free, honest assessment. No packages sold to players who don't need them.",
    "pricing.featured": "Most chosen",
    "pricing.freeFirst": "Free assessment first",
    "pricing.tailored": "Tailored pricing — free assessment first",
    "pricing.cta": "Start here",
    "pricing.p1sub": "Your recruiting foundation",
    "pricing.p1f": ["Coach-ready recruiting profile", "Highlight video and Athletic evaluation", "Player CV creation", "Academic consultation", "Honest level assessment"],
    "pricing.p2sub": "Full recruitment, end to end",
    "pricing.p2f": ["Everything in The Profile", "Direct outreach to coaches with a real spot in your position", "Offer comparison & scholarship guidance", "Anytime unlimited Q&A"],
    "pricing.p3sub": "A better fit, mid-journey",
    "pricing.p3f": ["Everything in The Crossing", "5 years of guidance through your university journey", "Transfer portal strategy", "New-fit program targeting", "Eligibility & credit guidance", "Offer negotiation, again"],

    "stories.chapter": "Chapter 04 — Crossings made",
    "stories.h2a": "Players who ",
    "stories.h2b": "crossed.",
    "stories.s1q": "They told me the honest answer was junior college. Eighteen months later I signed with an NAIA program — with a scholarship.",
    "stories.s1d": "NJCAA to NAIA — Defender, Spain",
    "stories.s2q": "Peter and Lilian didn't blast my profile everywhere. They found three coaches who actually needed a winger. Two made offers.",
    "stories.s2d": "NCAA Division II — Winger, France",
    "stories.s3q": "The transfer felt impossible from the inside. They mapped the portal, the credits, the timing — and found me a program that fits.",
    "stories.s3d": "Transfer — Midfielder, United States",

    "contact.chapter": "Chapter 05 — Your move",
    "contact.h2a": "Start your ",
    "contact.h2b": "crossing.",
    "contact.copy": "Tell us where you play, where you study, and where you want to go. You'll get an honest answer — including if the honest answer is junior college. Every enquiry is read by Peter or Lilian personally.",
    "contact.whatsapp": "WhatsApp — chat with us",
    "contact.name": "Name *",
    "contact.email": "Email *",
    "contact.location": "Based in",
    "contact.position": "Position",
    "contact.message": "Your story *",
    "contact.namePh": "Your full name",
    "contact.locationPh": "City, country",
    "contact.select": "Select…",
    "contact.messagePh": "Where you play now, your grad year, where you want to go…",
    "contact.posGk": "Goalkeeper",
    "contact.posDf": "Defender",
    "contact.posMf": "Midfielder",
    "contact.posFw": "Forward / Winger",
    "contact.posOther": "Other",
    "contact.send": "Send it across",
    "contact.sending": "Sending…",
    "contact.ok": "Message sent. Peter or Lilian will reply within 48 hours.",
    "contact.err": "Something went wrong — email us directly instead.",

    "footer.cta": "Let's Talk",
    "footer.assessment": "Free, honest assessment",
    "footer.tagline": "From every shore, to North American soccer — © 2026",

    "auth.h1login": "Welcome back.",
    "auth.h1register": "Join the crossing.",
    "auth.subLogin": "Sign in to your recruiting profile.",
    "auth.subRegister": "Create your free player account.",
    "auth.login": "Sign in",
    "auth.register": "Create account",
    "auth.name": "Full name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.passwordHint": " (min. 8 characters)",
    "auth.namePh": "Your full name",
    "auth.busy": "One moment…",
    "auth.forgot": "Forgot your password?",
    "auth.back": "Back to site",
    "auth.okLogin": "Welcome back.",
    "auth.okRegister": "Account created — now build your profile.",

    "dash.h1a": "My recruiting ",
    "dash.h1b": "profile.",
    "dash.back": "Back to site",
    "dash.signout": "Sign out",
    "dash.name": "Full name",
    "dash.location": "Based in",
    "dash.gradyear": "Grad year",
    "dash.height": "Height",
    "dash.gpa": "GPA",
    "dash.position": "Position",
    "dash.foot": "Preferred foot",
    "dash.club": "Current club",
    "dash.highlight": "Highlight video link",
    "dash.bio": "About you",
    "dash.locationPh": "City, country",
    "dash.heightPh": "6'1\" / 185cm",
    "dash.clubPh": "Club, academy or school",
    "dash.bioPh": "Honours, stats, what you're looking for…",
    "dash.select": "Select…",
    "dash.save": "Save profile",
    "dash.saving": "Saving…",
    "dash.saved": "Profile saved.",
    "dash.loadErr": "Could not load your profile.",
    "dash.addPhoto": "Add your photo",
    "dash.changePhoto": "Change photo",
    "dash.uploading": "Uploading…",
    "dash.photoOk": "Photo updated.",
    "dash.photoHint": "JPG, PNG or WebP · max 8 MB",
    "dash.sendH2": "Ready when you are.",
    "dash.sendCopy": "One tap sends your saved profile straight to Peter and Lilian's inbox as a recruiting enquiry.",
    "dash.sendBtn": "Send my profile",
    "dash.sending": "Sending…",
    "dash.sentOk": "Profile sent — Peter or Lilian will get back to you within 48 hours.",
    "dash.posGk": "Goalkeeper",
    "dash.posDf": "Defender",
    "dash.posMf": "Midfielder",
    "dash.posFw": "Forward / Winger",
    "dash.posOther": "Other",
    "dash.footR": "Right",
    "dash.footL": "Left",
    "dash.footB": "Both",

    "reset.h1new": "New password.",
    "reset.h1reset": "Reset password.",
    "reset.back": "Back to sign in",
    "reset.email": "Your account email",
    "reset.newPw": "New password (min. 8 characters)",
    "reset.sendLink": "Send reset link",
    "reset.update": "Update password",
    "reset.busy": "One moment…",
    "reset.doneNew": "Your password has been updated.",
    "reset.doneSent": "Check your inbox — if an account exists for that email, a reset link is on its way.",
    "reset.goLogin": "Go to sign in",
    "reset.okNew": "Password updated — sign in with your new password.",
    "reset.okSent": "If an account exists, a reset link is on its way to your inbox.",

    "admin.deniedH1": "Admin only.",
    "admin.deniedCopy": "Sign in with the founders' admin account to view enquiries and player profiles.",
    "admin.goLogin": "Go to sign in",
    "admin.back": "Back to site",
    "admin.signout": "Sign out",
    "admin.enquiries": "Enquiries",
    "admin.players": "Players",
    "admin.noEnquiries": "No enquiries yet — they'll land here when players reach out.",
    "admin.noPlayers": "No player accounts yet.",
    "admin.noDetails": "No details",
    "admin.unnamed": "Unnamed player",
    "admin.joined": "Joined",
    "admin.notFilled": "Profile not filled in yet.",
    "admin.club": "Club:",
    "admin.watch": "Watch highlights",
    "admin.classOf": "Class of",
    "admin.filterAll": "All",
  },

  fr: {
    "nav.founders": "Fondateurs",
    "nav.pathways": "Parcours",
    "nav.packages": "Formules",
    "nav.stories": "Témoignages",
    "nav.cta": "Parlons-en",
    "nav.login": "Connexion",
    "nav.dashboard": "Mon profil",
    "nav.admin": "Admin",

    "hero.kicker": "Recrutement soccer universitaire — US & Canada",
    "hero.l1": "La Traversée.",
    "hero.l2": "Votre passerelle vers",
    "hero.l3a": "le soccer ",
    "hero.l3b": "nord-américain.",
    "hero.sub": "Nous construisons votre profil de recrutement, le mettons devant des coachs qui ont réellement une place à votre poste, et restons avec vous pendant toute votre carrière universitaire. Des réponses honnêtes — même quand la réponse, c'est le junior college.",
    "hero.cta1": "Commencez votre traversée",
    "hero.cta2": "Qui sommes-nous",
    "hero.statline": "NCAA D1 · D2 · D3 — NAIA — NJCAA — U Sports",

    "founders.chapter": "Chapitre 01 — Ceux qui ont traversé",
    "founders.h2a": "Dirigé par deux joueurs qui ont fait la traversée ",
    "founders.h2b": "eux-mêmes.",
    "founders.intro": "Peter est allé du Texas au Canada. Lilian, de la France au Pays de Galles puis au Canada — Cape Breton, et maintenant un nouveau chapitre à Algoma University. Deux rives — et nous avons tous les deux fait la traversée. Si vous êtes joueur en Amérique du Nord ou en Europe, nous serons au bout de vos DMs.",
    "founders.peterCap": "Gardien — Texas → Canada",
    "founders.peterLabel": "Peter — Celui à qui on a dit d'arrêter les cages",
    "founders.peterBio": "À 10 ans, un coach lui a dit de penser à un autre poste. Il n'a pas écouté. Il a fini le lycée au Texas comme gardien deux fois first-team All-State — et le seul gardien de l'État à marquer deux coups francs, dont un qui a gagné une demi-finale d'État. Depuis : des bourses à Algoma et Trinity Western, plus de 1 000 minutes de soccer universitaire, des passages semi-pro avec Hill Country Lobos et Lake Travis FC. Il a été ce joueur qui attend des opportunités qui ne viennent jamais — il sait ce que le rejet signifie, et comment le surmonter.",
    "founders.peterAcademies": "Académie de gardiens @thekeeperslab · co-propriétaire @eptsoccer",
    "founders.lilianLabel": "Lilian — France → Pays de Galles → Canada",
    "founders.lilianBio": "De Paris à Cardiff, puis de l'autre côté de l'Atlantique à Cape Breton University — l'un des meilleurs environnements de soccer universitaire du pays. En chemin, il a aussi joué semi-pro pour Guelph United FC et Windsor City FC. Blessures et obstacles sont venus aussi, mais il a continué d'avancer. Aujourd'hui, il franchit une nouvelle étape : un transfert à Algoma University pour une nouvelle opportunité et un nouveau chapitre. Il a vécu le recrutement, le départ à l'étranger, l'adaptation à un nouveau système — et le processus de transfert quand les choses ne se passent pas comme prévu.",
    "founders.quote": "\u00ab Des retours honnêtes. De vrais conseils. De vraies opportunités. Pas de blabla, pas de fausses promesses — même quand la réponse honnête, c'est le junior college. \u00bb",
    "founders.stripPeter": "Peter — dans les buts",
    "founders.stripLilian": "Lilian — jour de match avec les Capers",

    "pathways.chapter": "Chapitre 02 — Toutes les portes qu'on ouvre",
    "pathways.h2a": "Six parcours. ",
    "pathways.h2b": "Un qui est",
    "pathways.h2c": " vraiment le vôtre.",
    "pathways.d1": "Le plus haut niveau — programmes à temps plein, retransmissions nationales, les effectifs les plus exigeants. Nous ne vous y poussons que si vous y avez vraiment votre place.",
    "pathways.d1tag": "Bourses sportives",
    "pathways.d2": "Du soccer de haut niveau avec de vraies bourses et plus d'équilibre. Le bon choix pour une grande partie des internationaux.",
    "pathways.d2tag": "Bourses partielles & complètes",
    "pathways.d3": "Pas de bourses sportives — mais du soccer sérieux et de solides aides académiques au mérite. Souvent le choix académique le plus malin.",
    "pathways.d3tag": "Aide au mérite",
    "pathways.d4": "Des programmes compétitifs, une éligibilité flexible et des coachs qui décident vite. Un vrai parcours, pas un lot de consolation.",
    "pathways.d4tag": "Bourses disponibles",
    "pathways.d5": "Le junior college. Parfois la réponse honnête — et parfois le chemin le plus rapide vers une meilleure offre deux ans plus tard.",
    "pathways.d5tag": "La réponse honnête",
    "pathways.d6": "U SPORTS est la meilleure ligue universitaire du Canada — très compétitive, avec un niveau de jeu qui surprend beaucoup de joueurs qui croient que c'est un cran sous la NCAA.",
    "pathways.d6tag": "Notre terrain",

    "pricing.chapter": "Chapitre 03 — Les formules",
    "pricing.h2a": "Choisissez votre ",
    "pricing.h2b": "traversée.",
    "pricing.intro": "Les tarifs sont adaptés à votre parcours et à votre calendrier — chaque collaboration commence par une évaluation gratuite et honnête. Aucune formule vendue aux joueurs qui n'en ont pas besoin.",
    "pricing.featured": "Le plus choisi",
    "pricing.freeFirst": "Évaluation gratuite d'abord",
    "pricing.tailored": "Tarifs sur mesure — évaluation gratuite d'abord",
    "pricing.cta": "Commencer",
    "pricing.p1sub": "Votre fondation recrutement",
    "pricing.p1f": ["Profil de recrutement prêt pour les coachs", "Vidéo highlight et évaluation athlétique", "Création de votre CV joueur", "Consultation académique", "Évaluation honnête de votre niveau"],
    "pricing.p2sub": "Recrutement complet, de A à Z",
    "pricing.p2f": ["Tout ce qui est dans The Profile", "Contact direct avec des coachs qui ont une vraie place à votre poste", "Comparaison des offres & conseils sur les bourses", "Questions-réponses illimitées, à tout moment"],
    "pricing.p3sub": "Un meilleur fit, en cours de route",
    "pricing.p3f": ["Tout ce qui est dans The Crossing", "5 ans d'accompagnement pendant votre parcours universitaire", "Stratégie transfer portal", "Recherche de programmes qui vous correspondent", "Conseils éligibilité & crédits", "Négociation des offres, à nouveau"],

    "stories.chapter": "Chapitre 04 — Traversées réussies",
    "stories.h2a": "Ceux qui ont ",
    "stories.h2b": "traversé.",
    "stories.s1q": "Ils m'ont dit que la réponse honnête, c'était le junior college. Dix-huit mois plus tard, je signais dans un programme NAIA — avec une bourse.",
    "stories.s1d": "NJCAA vers NAIA — Défenseur, Espagne",
    "stories.s2q": "Peter et Lilian n'ont pas envoyé mon profil partout. Ils ont trouvé trois coachs qui cherchaient vraiment un ailier. Deux ont fait une offre.",
    "stories.s2d": "NCAA Division II — Ailière, France",
    "stories.s3q": "Le transfert semblait impossible vu de l'intérieur. Ils ont cartographié le portal, les crédits, le timing — et m'ont trouvé un programme qui me correspond.",
    "stories.s3d": "Transfert — Milieu, États-Unis",

    "contact.chapter": "Chapitre 05 — À vous de jouer",
    "contact.h2a": "Commencez votre ",
    "contact.h2b": "traversée.",
    "contact.copy": "Dites-nous où vous jouez, où vous étudiez et où vous voulez aller. Vous aurez une réponse honnête — y compris si la réponse honnête, c'est le junior college. Chaque demande est lue personnellement par Peter ou Lilian.",
    "contact.whatsapp": "WhatsApp — discutez avec nous",
    "contact.name": "Nom *",
    "contact.email": "Email *",
    "contact.location": "Basé(e) à",
    "contact.position": "Poste",
    "contact.message": "Votre histoire *",
    "contact.namePh": "Votre nom complet",
    "contact.locationPh": "Ville, pays",
    "contact.select": "Choisir…",
    "contact.messagePh": "Où vous jouez, votre année de diplôme, où vous voulez aller…",
    "contact.posGk": "Gardien",
    "contact.posDf": "Défenseur",
    "contact.posMf": "Milieu",
    "contact.posFw": "Attaquant / Ailier",
    "contact.posOther": "Autre",
    "contact.send": "Envoyer votre message",
    "contact.sending": "Envoi…",
    "contact.ok": "Message envoyé. Peter ou Lilian vous répondra sous 48 heures.",
    "contact.err": "Une erreur est survenue — écrivez-nous directement par email.",

    "footer.cta": "Parlons-en",
    "footer.assessment": "Évaluation gratuite et honnête",
    "footer.tagline": "De toutes les rives, vers le soccer nord-américain — © 2026",

    "auth.h1login": "Bon retour.",
    "auth.h1register": "Rejoignez la traversée.",
    "auth.subLogin": "Connectez-vous à votre profil de recrutement.",
    "auth.subRegister": "Créez votre compte joueur gratuit.",
    "auth.login": "Connexion",
    "auth.register": "Créer un compte",
    "auth.name": "Nom complet",
    "auth.email": "Email",
    "auth.password": "Mot de passe",
    "auth.passwordHint": " (8 caractères min.)",
    "auth.namePh": "Votre nom complet",
    "auth.busy": "Un instant…",
    "auth.forgot": "Mot de passe oublié ?",
    "auth.back": "Retour au site",
    "auth.okLogin": "Bon retour.",
    "auth.okRegister": "Compte créé — construisez maintenant votre profil.",

    "dash.h1a": "Mon profil de ",
    "dash.h1b": "recrutement.",
    "dash.back": "Retour au site",
    "dash.signout": "Se déconnecter",
    "dash.name": "Nom complet",
    "dash.location": "Basé(e) à",
    "dash.gradyear": "Année de diplôme",
    "dash.height": "Taille",
    "dash.gpa": "GPA",
    "dash.position": "Poste",
    "dash.foot": "Pied fort",
    "dash.club": "Club actuel",
    "dash.highlight": "Lien vidéo highlight",
    "dash.bio": "À propos de vous",
    "dash.locationPh": "Ville, pays",
    "dash.heightPh": "1m85",
    "dash.clubPh": "Club, académie ou lycée",
    "dash.bioPh": "Distinctions, stats, ce que vous cherchez…",
    "dash.select": "Choisir…",
    "dash.save": "Enregistrer le profil",
    "dash.saving": "Enregistrement…",
    "dash.saved": "Profil enregistré.",
    "dash.loadErr": "Impossible de charger votre profil.",
    "dash.addPhoto": "Ajoutez votre photo",
    "dash.changePhoto": "Changer la photo",
    "dash.uploading": "Envoi…",
    "dash.photoOk": "Photo mise à jour.",
    "dash.photoHint": "JPG, PNG ou WebP · 8 Mo max",
    "dash.sendH2": "Prêt quand vous l'êtes.",
    "dash.sendCopy": "Un clic envoie votre profil enregistré directement dans la boîte mail de Peter et Lilian comme demande de recrutement.",
    "dash.sendBtn": "Envoyer mon profil",
    "dash.sending": "Envoi…",
    "dash.sentOk": "Profil envoyé — Peter ou Lilian vous répondra sous 48 heures.",
    "dash.posGk": "Gardien",
    "dash.posDf": "Défenseur",
    "dash.posMf": "Milieu",
    "dash.posFw": "Attaquant / Ailier",
    "dash.posOther": "Autre",
    "dash.footR": "Droit",
    "dash.footL": "Gauche",
    "dash.footB": "Les deux",

    "reset.h1new": "Nouveau mot de passe.",
    "reset.h1reset": "Réinitialiser le mot de passe.",
    "reset.back": "Retour à la connexion",
    "reset.email": "L'email de votre compte",
    "reset.newPw": "Nouveau mot de passe (8 caractères min.)",
    "reset.sendLink": "Envoyer le lien",
    "reset.update": "Mettre à jour",
    "reset.busy": "Un instant…",
    "reset.doneNew": "Votre mot de passe a été mis à jour.",
    "reset.doneSent": "Vérifiez votre boîte mail — si un compte existe pour cet email, un lien de réinitialisation est en route.",
    "reset.goLogin": "Aller à la connexion",
    "reset.okNew": "Mot de passe mis à jour — connectez-vous avec votre nouveau mot de passe.",
    "reset.okSent": "Si un compte existe, un lien de réinitialisation est en route vers votre boîte mail.",

    "admin.deniedH1": "Réservé aux admins.",
    "admin.deniedCopy": "Connectez-vous avec le compte admin des fondateurs pour voir les demandes et les profils joueurs.",
    "admin.goLogin": "Aller à la connexion",
    "admin.back": "Retour au site",
    "admin.signout": "Se déconnecter",
    "admin.enquiries": "Demandes",
    "admin.players": "Joueurs",
    "admin.noEnquiries": "Pas encore de demandes — elles arriveront ici quand des joueurs écriront.",
    "admin.noPlayers": "Pas encore de comptes joueurs.",
    "admin.noDetails": "Aucun détail",
    "admin.unnamed": "Joueur sans nom",
    "admin.joined": "Inscrit le",
    "admin.notFilled": "Profil pas encore rempli.",
    "admin.club": "Club :",
    "admin.watch": "Voir les highlights",
    "admin.classOf": "Promotion",
    "admin.filterAll": "Toutes",
  },
};
